<label [attr.for]="for" class="form-label"
       [ngClass]="{
       'danger-text': danger,
       'left-side': leftSide,
       }">
    {{ label }}
</label>
